'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _typeof = require('./../../external/@babel/runtime/helpers/esm/typeof.js');
var slicedToArray = require('./../../external/@babel/runtime/helpers/esm/slicedToArray.js');
var React = require('react');
var index = require('./../../external/classnames/index.js');
var PropTypes = require('prop-types');
var CardCarousel = require('../CardCarousel/CardCarousel.js');
var CarouselItem = require('../../composites/Carousel/CarouselItem/CarouselItem.js');
require('../../sections/Alert/Alert.js');
require('../../sections/Article/Article.js');
require('../../sections/ArticleInfoBlock/ArticleInfoBlock.js');
require('../../sections/Banner/Banner.js');
require('../../sections/BreadCrumbs/BreadCrumbs.js');
require('../../sections/ErrorPage/ErrorPage.js');
require('../../sections/FeatureCarousel/FeatureCarousel.js');
require('../../sections/FeatureCarousel/FeaturedCarouselItem/FeaturedCarouselItem.js');
require('../../sections/FeaturedMarquee/FeaturedMarquee.js');
require('../../sections/NewsletterSubscription/NewsletterSubscription.js');
require('../../sections/OpenPositions/OpenPositions.js');
require('../../sections/OurTeam/OurTeam.js');
require('../../sections/PageHeader/PageHeader.js');
require('../../sections/Pagination/Pagination.js');
require('../../sections/PaginationContainer/PaginationContainer.js');
require('../../sections/PanelGroup/PanelGroup.js');
require('../../sections/PanelGroup/Panel/Panel.js');
require('../../sections/PodcastCarousel/PodcastCarousel.js');
require('../../sections/SecondaryNav/SecondaryNav.js');
var Section = require('../../sections/Section/Section.js');
require('../../sections/Section/SectionHeader/SectionHeader.js');
require('../../sections/SplitBanner/SplitBanner.js');
require('../../sections/SplitBanner/SplitBannerImage/SplitBannerImage.js');
require('../../sections/SplitBanner/SplitBannerVideo/SplitBannerVideo.js');
require('../../sections/SplitBanner/SplitBannerContent/SplitBannerContent.js');
require('../../sections/SplitBanner/SplitBannerContact/SplitBannerContact.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

/**
 *
 * @param {Object} props
 * @param {string} [props.id] - id of the section
 * @param {string} [props.heading] - heading of the section
 * @param {{src: string, alt: string, caption: string, srcSet?: string}[]} props.images - array of images to display in the gallery
 * @param {boolean} [props.isLinkable] - whether the section is linkable
 * @param {string} [props.className] - additional classes to apply to the section
 * @param {string} [props.modalSlideClass] - class to apply to Modal Slides
 */
var Gallery = function Gallery(_ref) {
  var id = _ref.id,
    heading = _ref.heading,
    images = _ref.images,
    isLinkable = _ref.isLinkable,
    className = _ref.className,
    _ref$modalSlideClass = _ref.modalSlideClass,
    modalSlideClass = _ref$modalSlideClass === void 0 ? 'modal-slides' : _ref$modalSlideClass;
  var _useState = React.useState(false),
    _useState2 = slicedToArray.default(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var _useState3 = React.useState(1),
    _useState4 = slicedToArray.default(_useState3, 2),
    currentSlideIndex = _useState4[0],
    setCurrentSlideIndex = _useState4[1];
  React.useEffect(function () {
    setVisibleSlide(currentSlideIndex);
  }, [currentSlideIndex]);
  var galleryClasses = index.default('lanl-gallery', className);
  var modalClasses = index.default('lanl-gallery-modal', showModal && 'open');
  var modalSlideClasses = index.default('lanl-modal-slide', modalSlideClass);
  var openModal = function openModal(slideIndex) {
    setCurrentSlide(~~slideIndex);
    setShowModal(true);
  };
  var moveSlidesBy = function moveSlidesBy(step) {
    setCurrentSlideIndex(currentSlideIndex + step);
    setVisibleSlide(currentSlideIndex);
  };
  var setCurrentSlide = function setCurrentSlide(slideIndex) {
    setCurrentSlideIndex(slideIndex);
    setVisibleSlide(slideIndex);
  };
  var setVisibleSlide = function setVisibleSlide(slideIndex) {
    var slides = /** @type {HTMLCollectionOf<HTMLElement>} */
    document.getElementsByClassName(modalSlideClass);
    if (slideIndex > slides.length) {
      setCurrentSlideIndex(1);
    }
    if (slideIndex < 1) {
      setCurrentSlideIndex(slides.length);
    }
    for (var i = 0; i < slides.length; i++) {
      var display = i === currentSlideIndex - 1 ? 'block' : 'none';
      slides[i].style.display = display;
    }
  };
  return /*#__PURE__*/React__default.default.createElement(Section.Section, {
    id: id,
    "data-testid": "lanl-gallery",
    isLinkable: isLinkable,
    noStyling: true,
    className: galleryClasses
  }, heading && /*#__PURE__*/React__default.default.createElement("h3", {
    className: "gallery-heading"
  }, heading), /*#__PURE__*/React__default.default.createElement(CardCarousel.CardCarousel, {
    length: images.length,
    cardSizeLg: 600,
    cardSizeSm: 600
  }, images.map(function (_ref2, index) {
    var src = _ref2.src,
      alt = _ref2.alt,
      caption = _ref2.caption,
      srcSet = _ref2.srcSet;
    return /*#__PURE__*/React__default.default.createElement(CarouselItem.CarouselItem, {
      key: "gallery-carousel-item-".concat(index),
      className: "gallery-carousel-item",
      itemId: index,
      card: true
    }, /*#__PURE__*/React__default.default.createElement("figure", null, /*#__PURE__*/React__default.default.createElement("img", {
      srcSet: srcSet,
      src: src,
      sizes: "560px",
      alt: alt,
      loading: "lazy",
      width: "560",
      height: "450",
      onClick: function onClick(e) {
        return openModal(e.currentTarget.getAttribute('data-slide-index'));
      },
      "data-slide-index": index + 1
    }), caption && /*#__PURE__*/React__default.default.createElement("figcaption", {
      className: "carousel-image-caption",
      title: caption
    }, caption)));
  })), /*#__PURE__*/React__default.default.createElement("div", {
    className: modalClasses
  }, /*#__PURE__*/React__default.default.createElement("div", {
    className: "toolbar"
  }, /*#__PURE__*/React__default.default.createElement("span", {
    className: "close",
    onClick: function onClick() {
      return setShowModal(false);
    }
  }, "\xD7")), /*#__PURE__*/React__default.default.createElement("div", {
    className: "content"
  }, images.map(function (_ref3, index) {
    var src = _ref3.src,
      alt = _ref3.alt,
      caption = _ref3.caption,
      srcSet = _ref3.srcSet;
    return /*#__PURE__*/React__default.default.createElement("div", {
      className: modalSlideClasses,
      key: "modal-slide-".concat(index)
    }, /*#__PURE__*/React__default.default.createElement("div", {
      className: "slide-number"
    }, "".concat(index + 1, "/").concat(images.length)), /*#__PURE__*/React__default.default.createElement("figure", null, /*#__PURE__*/React__default.default.createElement("img", {
      srcSet: srcSet,
      sizes: "100vw",
      src: src,
      alt: alt,
      loading: "lazy"
    }), caption && /*#__PURE__*/React__default.default.createElement("figcaption", {
      className: "modal-image-caption"
    }, caption)));
  })), /*#__PURE__*/React__default.default.createElement("div", {
    className: "arrow-left"
  }, /*#__PURE__*/React__default.default.createElement("button", {
    onClick: function onClick() {
      moveSlidesBy(-1);
    }
  }, "\u276E")), /*#__PURE__*/React__default.default.createElement("div", {
    className: "arrow-right"
  }, /*#__PURE__*/React__default.default.createElement("button", {
    onClick: function onClick() {
      moveSlidesBy(1);
    }
  }, "\u276F"))));
};
Gallery.defaultProps = {
  classNames: '',
  heading: '',
  id: null,
  images: [],
  isLinkable: false,
  modalSlideClass: 'modal-slides'
};
Gallery.propTypes = {
  images: PropTypes__default.default.arrayOf(PropTypes__default.default.shape({
    src: PropTypes__default.default.string.isRequired,
    alt: PropTypes__default.default.string,
    caption: PropTypes__default.default.string,
    srcSet: PropTypes__default.default.string
  })).isRequired,
  className: PropTypes__default.default.string,
  heading: PropTypes__default.default.string,
  id: function id(props, propName, componentName) {
    if (props['isLinkable'] && !props[propName]) {
      return new Error('id prop is required if isLinkable prop is true');
    }
    if (props[propName] && typeof props[propName] !== 'string') {
      return new Error("Invalid prop id of type '".concat(_typeof.default(props[propName]), "' supplied to '").concat(componentName, "', expected 'string' "));
    }
  },
  isLinkable: PropTypes__default.default.bool,
  modalSlideClass: PropTypes__default.default.string
};

exports.Gallery = Gallery;
exports.default = Gallery;
//# sourceMappingURL=Gallery.js.map
